import axiosClient from "../axios/axiosClient";

export function getMilestones() {
  return axiosClient.get("/milestones");
}

export function getMilestone(milestoneId) {
  return axiosClient.get(`/milestones/${milestoneId}`);
}

export function createMilestone(data) {
  return axiosClient.post("/milestones", data);
}

export const updateMilestone = (milestoneId, data) => {
  return axiosClient.put(`/milestones/${milestoneId}`, data);
};

export function deleteMilestone(milestoneId) {
  return axiosClient.delete(`/milestones/${milestoneId}`);
}
